import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { AppRoutes } from '../../config';

class NotFound extends Component<any, any> {
  componentDidMount = () => {
    const header: HTMLElement | null = document.getElementById('mainHeader');
    if (header) {
      header.classList.add('inner-head');
    }
  };
  render() {
    return (
      <React.Fragment>
        <section className='error-section'>
          <div className='container'>
            <div className='text-center'>
              <div className='text-notfound'>404!</div>
              <h1 className='score-text'>Sorry, The Page not found</h1>
              <p>
                We’re sorry, the page you have looked for does not exist in our
                database! Maybe go to our home page.
              </p>

              <div className='text-center my-4'>
                <Link className='slider-btn' to={AppRoutes.HOME}>
                  Back to home{' '}
                </Link>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default NotFound;
